import TaskAction, { TaskActionDTO } from 'models/onboarding/process/action/TaskAction';

export default class TaskActionService {
	toModel(process: TaskActionDTO): TaskAction {
		return new TaskAction(process);
	}
}
